<template>
	<!-- <v-container fluid> -->
		<list-admin></list-admin>
	<!-- </v-container> -->
</template>


<script>
	// import HelloWorld from '../components/HelloWorld'
	import ListAdmin from '../components/ListAdmin.vue'

	export default {
		name: 'Lists',

		components: {
			ListAdmin,
		},
	}
</script>